export default __webpack_public_path__ + "static/media/LENS_CULINARIS_DEFAULT_complete_2.5809e283.jpg";